module.exports = ".preview-image{\n    text-align: center;\n}\n.fileButton{\n    text-align: center;\n}\nimg{\n    width: 20%;\n}\n"